import { render, staticRenderFns } from "./ImgUploadIntro.vue?vue&type=template&id=bf1f7c5a&scoped=true"
import script from "./ImgUploadIntro.vue?vue&type=script&lang=js"
export * from "./ImgUploadIntro.vue?vue&type=script&lang=js"
import style0 from "./ImgUploadIntro.vue?vue&type=style&index=0&id=bf1f7c5a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1f7c5a",
  null
  
)

export default component.exports